<script setup lang="ts">
const { isVisible } = useUnsupportedIPadOS();
</script>

<template>
  <div
    v-if="isVisible"
    role="alert"
    class="z-[100] border-b border-amber-200 bg-amber-50 px-4 py-3 text-sm text-gray-900 text-center"
  >
    <div class="container mx-auto max-w-6xl text-center">
      {{ $t("unsupportedIPadOS.message") }}
      <a
        :href="$t('unsupportedIPadOS.updateLink')"
        target="_blank"
        rel="noopener noreferrer"
        class="ml-1 font-medium text-gray-900 underline underline-offset-2 hover:text-gray-700"
      >
        {{ $t("unsupportedIPadOS.updateLinkText") }}
      </a>
    </div>
  </div>
</template>
